import { type ReactElement } from 'react'

import styles from './FeaturedCommonStats.module.scss'

type Props = {
  statElements: ReactElement[]
}
export const FeaturedCommonStats = ({ statElements }: Props) => (
  <ul className={styles.container}>
    {statElements.map((statElement, i) => (
      <li className={styles.item} key={i}>
        {statElement}
      </li>
    ))}
  </ul>
)
